import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client/react/hooks/useQuery'
import { TrainingMembershipCompletionDateDocument } from 'generated/resources/graphql'

import { EditCompletionDateModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/EditCompletionDateModal'

const UpdateCompletionDate = () => {
  const { membershipId, id } = useParams()
  const { data } = useQuery(TrainingMembershipCompletionDateDocument, {
    variables: { id: Number(membershipId), trainingId: Number(id) },
  })
  const completionDate = data?.trainings?.trainingMembership?.trainingCompletedAt
  return (
    <EditCompletionDateModal
      id={Number(id)}
      completionDate={String(completionDate)}
      membershipId={Number(membershipId)}
    />
  )
}

export default UpdateCompletionDate
